import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import FamilyAlbumAddChild from "./FamilyAlbumAddChild";
import { useLocation } from "react-router-dom";

const FamilyAlbumAdd = () => {
  const { state } = useLocation();
  const familyDetails = state;
  return (
    <MainTemplate>
      <CardBackground>
        <FamilyAlbumAddChild familyDetails={familyDetails} />
      </CardBackground>
    </MainTemplate>
  );
};

export default FamilyAlbumAdd;
